<template>
    <div class="box">
        <div class="fields">
            <div class="field action">
                <label for="action-form-control">
                    {{ t("retentionReport-cohort-action_label") }}
                </label>
                <select id="action-form-control" name="action" class="form-control" v-model="selectedAction">
                    <option
                        v-for="option in actions"
                        :value="option"
                        :key="option.id"
                    >
                        {{ actionsLabels[option] }}
                    </option>
                </select>
            </div>
            <div
                :class="{ 'message-error': !selectedSegment }"
                class="field segments"
                v-if="
                    selectedAction === 'joined-segment' ||
                    selectedAction === 'left-segment'
                "
            >
                <label for="segment-form-control">
                    {{ t("retentionReport-cohort-segment_label") }}
                </label>
                <select id="segment-form-control" name="segment" class="form-control" v-model="selectedSegment">
                    <option value="">
                        {{ t("retentionReport-cohort-select_segment") }}
                    </option>
                    <option
                        v-for="option in segments"
                        :value="option.id"
                        :key="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="field cohort-type" v-if="selectedAction === 'order'">
                <label for="order-form-control">
                    {{ t("retentionReport-cohort-view_by") }}
                </label>
                <select id="order-form-control" name="cohortType" class="form-control" v-model="selectedCohortType">
                    <option :value="'period'">
                        {{ t("retentionReport-cohort-view_period") }}
                    </option>
                    <option :value="'orders'">
                        {{ t("retentionReport-cohort-view_orders") }}
                    </option>
                </select>
            </div>
            <div class="field interval">
                <label for="interval-form-control">
                    {{ t("retentionReport-cohort-interval_label") }}
                </label>
                <select id="interval-form-control" name="interval" class="form-control" v-model="selectedInterval">
                    <option
                        v-for="option in allowedIntervals"
                        :value="option"
                        :key="option.id"
                    >
                        {{ intervalLabels[option] }}
                    </option>
                </select>
            </div>
            <div class="field">
                <button class="btn btn-primary" @click="refresh">
                    <span class="far fa-spinner"></span>
                </button>
            </div>
        </div>
        <div class="cohort">
            <table v-if="series && series.length > 0 && series[0] && series[0].series">
                <tr>
                    <td></td>
                    <td v-for="(n, index) in series[0].series" :key="index">
                        {{ cohortType === "period" ? index : n.orders }}
                    </td>
                </tr>
                <tr v-for="(s, indexRow) in series" :key="indexRow">
                    <td>
                        <human-date :date="s.start" :format="labelFormat" />
                        <br />
                        <small>{{ s.value }}</small>
                    </td>
                    <td
                        v-for="(ss, indexCol) in s.series"
                        :key="indexCol"
                        class="cohort-cell"
                        :style="{
                            color:
                                percent(s.value, ss.value) > 70
                                    ? 'white'
                                    : 'black',
                        }"
                        @click="setActiveCell(indexRow, indexCol)"
                    >
                        <div
                            class="background white"
                            :class="{ 'semi-active': semiActive(ss) }"
                        ></div>
                        <div
                            v-if="ss.value"
                            class="background"
                            :class="{
                                active:
                                    indexRow === activeCell[0] &&
                                    indexCol === activeCell[1],
                                'semi-active': semiActive(ss),
                            }"
                            :style="{
                                opacity: percent(s.value, ss.value) / 100,
                            }"
                        ></div>
                        <div class="value">
                            {{ percent(s.value, ss.value) }}% <br />
                            <small> {{ ss.value }}</small>
                        </div>
                    </td>
                </tr>
            </table>
            <div v-else class="no-data">
                <p>{{ t("retentionReport-cohort-no_data") }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "cohort-chart",
    props: {
        series: {
            type: Array,
            default: () => [],
        },
        interval: {
            type: String,
            default: "",
        },
        cohortType: {
            type: String,
            default: "",
        },
        allowedIntervals: {
            type: Array,
            default: () => [],
        },
        segments: {
            type: Array,
            default: () => [],
        },
        extra: {
            type: Object,
            default: () => {},
        },
        action: {
            type: String,
            default: "",
        },
    },
    data() {
        let actions = ["order"];
        if (this.$module("segments")) {
            actions.push("joined-segment");
            actions.push("left-segment");
        }
        return {
            activeCell: [],
            selectedCohortType: this.cohortType || "period",
            selectedAction: this.action,
            selectedSegment: this.extra.segment_id || "",
            selectedInterval: this.interval,
            actions,
        };
    },
    computed: {
        labelFormat() {
            switch (this.interval) {
                case "daily":
                    return this.t("dates-format_date");
                case "weekly":
                    return this.t("dates-format_date");
                case "monthly":
                    return this.t("dates-format_month_year");
                case "yearly":
                    return this.t("dates-format_year");
                default:
                    return this.t("dates-format_date");
            }
        },
        intervalLabels() {
            return {
                daily: this.t("retentionReport-cohort-interval_daily"),
                weekly: this.t(
                    "retentionReport-cohort-interval_weekly",
                ),
                monthly: this.t(
                    "retentionReport-cohort-interval_monthly",
                ),
                yearly: this.t(
                    "retentionReport-cohort-interval_yearly",
                ),
            };
        },
        actionsLabels() {
            return {
                order: this.t("retentionReport-cohort-action_order"),
                "joined-segment": this.t(
                    "retentionReport-cohort-action_joined_segment",
                ),
                "left-segment": this.t(
                    "retentionReport-cohort-action_left_segment",
                ),
            };
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        semiActive(col) {
            if (this.activeCell.length === 2 && this.series && this.series.length > 0) {
                const rowIndex = this.activeCell[0];
                const colIndex = this.activeCell[1];
                if (this.cohortType === "period" &&
                    this.series[rowIndex] &&
                    this.series[rowIndex]["series"] &&
                    this.series[rowIndex]["series"][colIndex]) {
                    return (
                        col["start"] ===
                        this.series[rowIndex]["series"][colIndex]["start"]
                    );
                }
            }
            return false;
        },
        setActiveCell(rowIndex, colIndex) {
            if (this.series &&
                this.series[rowIndex] &&
                this.series[rowIndex]["series"] &&
                this.series[rowIndex]["series"][colIndex]) {
                this.activeCell = [rowIndex, colIndex];
                this.$emit("change-active-cell", {
                    row: this.series[rowIndex],
                    column: this.series[rowIndex]["series"][colIndex],
                });
            }
        },
        percent(total, value) {
            if (total === 0) {
                return 0;
            }
            const ratio = (value / total) * 100;
            return ratio.toFixed(2);
        },
        refresh() {
            let settings = {
                interval: this.selectedInterval,
                action: this.selectedAction,
                cohortType: this.selectedCohortType,
                props: {},
            };
            if (
                settings.action === "joined-segment" ||
                settings.action === "left-segment"
            ) {
                settings.props.segment_id = this.selectedSegment;
                if (this.selectedSegment == "" || !this.selectedSegment) return;
            }
            this.$emit("refresh", settings);
        },
    },
    watch: {
        selectedAction() {
            this.selectedCohortType = "period";
        },
    },
};
</script>
<style lang="less" scoped>
@import url("../../colors.less");

.fields {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    .field {
        display: flex;
        align-items: center;
        margin-left: 10px;
        label {
            width: auto;
            display: block;
        }
        .form-control {
            width: 220px;
            margin: 0 0 0 10px;
        }

        &.interval .form-control {
            width: 150px;
        }
    }
}
.cohort {
    background: #fff;
    padding: 0;
    overflow-x: auto;
    width: 100%;
    margin-right: 20px;

    .no-data {
        padding: 40px;
        text-align: center;
        color: #666;
        font-style: italic;
    }
}
.message-error {
    color: #e5322c;
    select {
        border-color: #e5322c;
    }
}
table {
    width: 100%;
    table-layout: fixed;
    td {
        padding: 7px 4px;
        border: none;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        width: 45px;
        position: relative;
        background: transparent;
        &:first-child {
            width: 70px;
        }
        &.cohort-cell {
            cursor: pointer;
        }
        .background {
            background: @mainColor;
            position: absolute;
            width: calc(100%);
            height: calc(100%);
            left: 0px;
            top: 0px;
            z-index: 0;
            &.white {
                background: #fff;
                border: 1px solid #f5f5f5;
            }
            &.active {
                background: #d99c1b;
            }
            &.semi-active {
                border: 3px solid #333232;
            }
        }

        .value {
            position: relative;
            small {
                opacity: 0.7;
            }
        }

        &:first-child {
            text-align: right;
            padding-right: 10px;
        }
    }
    tr:nth-child(even) {
        background: #f5f5f5;
    }
    tr:first-child td:not(:first-child):nth-child(2n) {
        background: #f5f5f5;
    }
}
</style>
